import ArrowDropDown from '@mui/icons-material/ArrowDropDown';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Popover from '@mui/material/Popover';
import React from 'react';
import { Link } from 'react-router-dom';
import { labelToID } from '../../../../util/util';

interface Props {
	links: any[];
	actions: any[];
	children: any;
}

export default function HeaderUserDropdown({
	links,
	actions,
	children,
}: Props) {
	const [anchorEl, setAnchorEl] = React.useState(null);

	const hasLinks = links && links.length;
	const hasActions = actions && actions.length;

	if (!hasLinks && !hasActions) {
		return null;
	} // do not display button if there are no links or actions

	const handleClick = (event: any) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	return (
		<>
			<Button
				id='AppBar__Button--UserDropdown'
				onClick={handleClick}
				sx={{ whiteSpace: 'nowrap', color: 'black.main' }}
				endIcon={<ArrowDropDown />}
			>
				{children}
			</Button>
			<Popover
				id='UserDropdown'
				anchorEl={anchorEl}
				keepMounted
				open={Boolean(anchorEl)}
				onClose={handleClose}
				sx={{ mt: 2 }}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'right',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'right',
				}}
			>
				{/*
					checks if items or actions exist, allowing this component to be used if 
					only a list of items or only a list of buttons is passed in
					(if both are passed in, the divider is rendered)
				*/}
				<List id='UserDropdown__List'>
					{links.length
						? links.map((listItem, index) => {
								return listItem.callback ? (
									<ListItem
										key={index}
										id={`UserDropdown__ListItem--${labelToID(listItem.label)}`}
										disablePadding
									>
										<ListItemButton
											component={Link}
											to={listItem.callback ? listItem.callback() : null}
											onClick={() => handleClose()}
											color='inherit'
										>
											<ListItemIcon sx={{ mr: 2, minWidth: 24 }}>
												{listItem.icon}
											</ListItemIcon>

											<ListItemText primary={listItem.label} />
										</ListItemButton>
									</ListItem>
								) : (
									<>
										<ListItem
											key={index}
											id={`UserDropdown__ListItem--${labelToID(
												listItem.label,
											)}`}
										>
											<ListItemIcon sx={{ mr: 2, minWidth: 24 }}>
												{listItem.icon}
											</ListItemIcon>

											<ListItemText primary={listItem.label} />
										</ListItem>
										<Divider sx={{ my: 1 }} />
									</>
								);
						  })
						: null}

					{actions.length
						? actions.map((listItem, index) => {
								return (
									<ListItem
										key={index}
										id={`UserDropdown__ListAction--${labelToID(
											listItem.label,
										)}`}
										disablePadding
									>
										<ListItemButton
											onClick={() => {
												listItem.callback();
												handleClose();
											}}
											color='inherit'
										>
											<ListItemIcon sx={{ mr: 2, minWidth: 24 }}>
												{listItem.icon}
											</ListItemIcon>

											<ListItemText primary={listItem.label} />
										</ListItemButton>
									</ListItem>
								);
						  })
						: null}
				</List>
			</Popover>
		</>
	);
}
